import './WifiOnboardingHeader.css';

import React from 'react';
import { VentionLogo } from '@src/assets';
import { WifiConnectionStatus, RemoteAccessStatus } from '@src/components';

export const WifiOnboardingHeader = (): JSX.Element => {
  return (
    <div id="wifi_onboarding_header">
      <div id="wifi_onboarding_header_controls">
        <div className="vention-logo-container">
          <VentionLogo id="vention-logo"/>
        </div>
        <div id="wifi_onboarding_header_connectivity">
          <RemoteAccessStatus />
          <WifiConnectionStatus />
        </div>
      </div>
      <div id="wifi_onboarding_header_title">Welcome to Vention</div>
    </div>
  );
};
